import { render, staticRenderFns } from "./VenueAdd.vue?vue&type=template&id=6bc28b8f&"
import script from "./VenueAdd.vue?vue&type=script&lang=js&"
export * from "./VenueAdd.vue?vue&type=script&lang=js&"
import style0 from "./VenueAdd.vue?vue&type=style&index=0&id=6bc28b8f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports